require.register("app/restaurant/show/BookmarkTab", function(exports, require, module){
  $0
  
});

